/**
 * LpFixedCta
 * SP追従CTAを、KV内のCTAを過ぎてから下からせり上げて出す。
 *
 * - 監視するのは `.p-lp-kv-head .p-lp-cta-row`。同じ内容のCTAがKVの中にあるので、
 *   それが画面から外れてから帯が引き継ぐ。`-row` はCTAの最後の子（サブボタン＋保証タグ）
 *   なので、下端＝CTA全体の下端。
 * - **IntersectionObserver は使わない。**「まだ下にある（非交差）」から
 *   「上へ抜けた（非交差）」へ、交差する状態を挟まずに飛ぶとコールバックが出ず、
 *   帯が出ないままになる（ハッシュ付きURLでの直接ジャンプなどで起きる）。
 * - 隠すのはCSSの既定で、ここは `is-visible` を付け外しするだけ。本体の ScrollTop と同じ組み方。
 *   JS側で隠す形にすると、付けるまでの一瞬だけ帯が出てしまう。
 * - PCはCSSで `display: none` なので、判定が動いても表には出ない。
 */

export default class LpFixedCta {
  /**
   * @param {HTMLElement} root
   */
  constructor(root) {
    this.root = root;
    this.trigger = document.querySelector('.p-lp-kv-head .p-lp-cta-row');
    if (!this.trigger) {
      return;
    }

    this.onScroll = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.onScroll();
  }

  onScroll() {
    this.root.classList.toggle('is-visible', this.trigger.getBoundingClientRect().bottom < 0);
  }

  destroy() {
    window.removeEventListener('scroll', this.onScroll);
  }
}
